// Axion Elite — Product Form
// Variant selection state + add-to-cart AJAX with optimistic UI.

(function () {
  function init() {
    var form = document.getElementById('axion-product-form');
    if (!form) return;

    var variantInput  = form.querySelector('[name="id"]');
    var addBtn        = form.querySelector('.product-add-to-cart');
    var optionButtons = form.querySelectorAll('.product-option-btn');

    // --- Variant selection ---
    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var groupName = btn.dataset.optionName;

        // Deselect siblings in the same group
        form.querySelectorAll('.product-option-btn[data-option-name="' + groupName + '"]')
          .forEach(function (b) { b.classList.remove('is-selected'); });

        btn.classList.add('is-selected');
        resolveVariant();
      });
    });

    function resolveVariant() {
      // Build a map of currently selected option values
      var selected = {};
      form.querySelectorAll('.product-option-btn.is-selected').forEach(function (b) {
        selected[b.dataset.optionName] = b.dataset.optionValue;
      });

      // Find matching variant from embedded JSON
      var variantsEl = document.getElementById('axion-variants-json');
      if (!variantsEl) return;

      var variants;
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

      var match = variants.find(function (v) {
        return v.options.every(function (opt) {
          return selected[opt.name] === opt.value;
        });
      });

      if (match) {
        variantInput.value = match.id;
        updateAddBtn(match);

        // Notify gallery to scroll to variant image
        if (match.featured_image) {
          document.dispatchEvent(new CustomEvent('axion:variant-image', {
            detail: { imageId: String(match.featured_image.id) }
          }));
        }
      }
    }

    // --- Add to cart AJAX ---
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = variantInput.value;
      if (!variantId) return;

      var originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      })
      .then(function () {
        // Update cart count in header
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badge = document.getElementById('axion-cart-count');
        if (badge) badge.textContent = cart.item_count;
        window.location.href = '/cart';
      })
      .catch(function () {
        addBtn.textContent = originalLabel;
        addBtn.disabled = false;
      });
    });

    function updateAddBtn(variant) {
      if (!variant.available) {
        addBtn.textContent = 'Sold out';
        addBtn.disabled = true;
      } else {
        addBtn.textContent = 'Add to cart';
        addBtn.disabled = false;
      }
    }

    // Init first variant selected state
    var firstPerGroup = {};
    optionButtons.forEach(function (btn) {
      var name = btn.dataset.optionName;
      if (!firstPerGroup[name]) {
        firstPerGroup[name] = true;
        btn.classList.add('is-selected');
      }
    });
    resolveVariant();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
